import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import FavoriteCreditCardForm from './FavoriteCreditCardForm';


const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: `100px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `90%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `90%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `90%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `90%`,
        },
    },
    logotwo: {
        [theme.breakpoints.up('xs')]: {
            width: `70px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `80%`,
        },
    },
    icon: {
        [theme.breakpoints.up('xs')]: {
            minWidth: '56px'
        },
        [theme.breakpoints.up('sm')]: {
            width: `40%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `24%`,
        },
    },
    listItems: {
        [theme.breakpoints.up('xs')]: {
            color: 'white',
            fontSize: '70%'
        },
        [theme.breakpoints.up('sm')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('md')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('lg')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('xl')]: {
            color: 'white',
            fontSize: '100%'
        },
    },
    imgLogo: {height: '40%'},
    styleaccordion : {
        borderLeft: '3px solid #0073D2',
        // backgroundColor : "#5A5759",
        color : "black",
        minWidth : "100%",
        width: `100%`,
    },
    colorbutton : {
        backgroundColor : "rgb(101,174,46);",
        color : "white",
        "&:hover": {
            backgroundColor : "rgb(101,174,46);",
            color : "white",
        }
    }
}));


const FavoriteCreditCardFormDialog = ( {  onCloseBeneficiaryForm, openBeneficiaryForm, onAcceptClick, beneficiaryFormDataExternal, clearForm, setEntity, setType, setDocument,  setInstitution, entities,
    institutions, handleChangeOpenAccordionInternal, openAccordionInternal}) => {
    //const [title, setTitle] = useState('Seleccione Cuenta del beneficiario');
    //const [expanded, setExpanded] = useState(true);
    //const [selected, setSelected] = useState(false);
    //const [typeFind, setTypeFind] = useState('cedule')
    const classes = useStyles();
    //console.log(entities)
    const handleSubmit = (values) => {
        onAcceptClick(values)
    }
    /* const handleSelectAccount = (value) => {
        const { numeroCuenta } = value
        setTitle(`${numeroCuenta} - ${nameInternal}`)
        getSelectAccount(value)
        setExpanded(false)
        setSelected(true)
    } */
    //functions
    /* const findAccountExist = (data) => {
        try {
            //console.log("Busca cedula",data)
            const { code } = data
            setTitle('Seleccione Cuenta del beneficiario')
            findAccountUser(code, typeFind )
            setSelected(false)
        } catch (error) {
            //console.log(error)
        }
        
    } */
    //const {name: nameInternal } = beneficiaryFormData
    const { cedule, name, beneficiary, number, entity, email, document, institution } = beneficiaryFormDataExternal
    
    let beneficiario = 'INTERNO'
    !beneficiary && (beneficiario = 'INTERNO')
    return (
            <Dialog
                
                open={ openBeneficiaryForm }
                onClose={ onCloseBeneficiaryForm }
                fullWidth={true}
                maxWidth= 'sm'
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{ 'Nuevo Beneficiario' }</DialogTitle>
                {/* <AppBar >
                    <Toolbar style = {{ position: 'relative', backgroundColor : "#2E2757"}}>
                        <IconButton edge="start" color="inherit" onClick={onCloseBeneficiaryForm} aria-label="close">
                            <CloseIcon style = {{color:'#FFFFFF'}}/>
                        </IconButton>
                        <Typography variant="h6" style = {{ flex: 1, color:'#FFFFFF', }}>
                            {'Nueva Tarjeta de Crédito'}
                        </Typography>
                    </Toolbar>
                </AppBar> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                        <br />
                                <FavoriteCreditCardForm 
                                    cedule = { cedule }
                                    email = {email} 
                                    name = { name }
                                    number = {number}
                                    entity = {entity}
                                    document = {document}
                                    institution = {institution}
                                    institutions = { institutions }
                                    setEntity = {setEntity}
                                    setType = { setType }
                                    setDocument = {setDocument}
                                    setInstitution = { setInstitution }
                                    beneficiary = { beneficiario }
                                    clearForm = { clearForm }
                                    entities = { entities }
                                    classes = { classes }
                                    onSubmit = { handleSubmit }
                                    cancelPrompt = { onCloseBeneficiaryForm }
                                    // findAccount = { findAccountExist }
                                />
                  </DialogContent>
                <DialogActions>
                </DialogActions>
        </Dialog>
    );
};

FavoriteCreditCardFormDialog.propTypes = {
    onCloseBeneficiaryForm: PropTypes.func.isRequired,
    findAccountUser: PropTypes.func.isRequired,
    openBeneficiaryForm: PropTypes.bool.isRequired,
    onAcceptClick: PropTypes.func.isRequired,
}

export default FavoriteCreditCardFormDialog;